import { ConcreteEncodable } from "./ConcreteEncodable";

import { TradeStatusRequestImplEncoder } from "../../encoder/TradeStatusRequestImplEncoder";

import * as CubiqTS from "../../index";
import { TradeStatusRequest } from "../TradeStatusRequest";

export class TradeStatusRequestImpl extends ConcreteEncodable implements TradeStatusRequest {
  public static enType: string = "com.bcdfx.model.event.TradeStatusRequestImpl";

  /*FID=1*/
  public accountCodes: Array<string> | null = null;
  /*FID=2*/
  public branchCds: Array<string> | null = null;
  /*FID=3*/
  public ccyPairs: Array<string> | null = null;
  /*FID=4*/
  public clientCodes: Array<string> | null = null;
  /*FID=5*/
  public dealIds: Array<CubiqTS.Long> | null = null;
  /*FID=6*/
  public fillComparitor: CubiqTS.DateComparitor | null = null;
  /*FID=7*/
  public fillUserIds: Array<CubiqTS.Long> | null = null;
  /*FID=8*/
  public maxResults: number;
  /*FID=9*/
  public orderIds: Array<CubiqTS.Long> | null = null;
  /*FID=10*/
  public orderTypes: Array<CubiqTS.OrderType> | null = null;
  /*FID=11*/
  public placingUserCodes: Array<string> | null = null;
  /*FID=12*/
  public products: Array<CubiqTS.Product> | null = null;
  /*FID=13*/
  public salesGroupIds: Array<CubiqTS.Long> | null = null;
  /*FID=14*/
  public traderGroupIds: Array<CubiqTS.Long> | null = null;
  /*FID=15*/
  public isConfirmedBySales: boolean;
  /*FID=16*/
  public includeComponentDetails: boolean;
  /*FID=17*/
  public includeDealConfirmations: boolean;
  /*FID=18*/
  public includeCounterPartyInformation: boolean;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TradeStatusRequestImplEncoder.Instance;
    this.setEncodableType(TradeStatusRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "TradeStatusRequestImpl[" +
      "accountCodes=" +
      this.accountCodes +
      "branchCds=" +
      this.branchCds +
      "ccyPairs=" +
      this.ccyPairs +
      "clientCodes=" +
      this.clientCodes +
      "dealIds=" +
      this.dealIds +
      "fillComparitor=" +
      this.fillComparitor +
      "fillUserIds=" +
      this.fillUserIds +
      "maxResults=" +
      this.maxResults +
      "orderIds=" +
      this.orderIds +
      "orderTypes=" +
      this.orderTypes +
      "placingUserCodes=" +
      this.placingUserCodes +
      "products=" +
      this.products +
      "salesGroupIds=" +
      this.salesGroupIds +
      "traderGroupIds=" +
      this.traderGroupIds +
      "isConfirmedBySales=" +
      this.isConfirmedBySales +
      "includeComponentDetails=" +
      this.includeComponentDetails +
      "includeDealConfirmations=" +
      this.includeDealConfirmations +
      "includeCounterPartyInformation=" +
      this.includeCounterPartyInformation +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
